import { postMessaje } from 'core/crud/lesson.crud';

import { useUser } from 'core/lite/hooks/useUser';
import { getLessonItemService } from 'core/services/lessonItem.service';
import { isNativeAppWebview } from 'core/utils/utils';
import { CONTENT_TYPES } from 'core/variables/constant';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useToasts } from 'react-toast-notifications';

function useMaterial({ course, courseGuid, lesson, lessonItem, onClickOpenDetailedView, user }) {
  const { t } = useTranslation(['types-resources', 'course', 'lesson', 'assigments', 'common']);
  const { user: currentUser } = useUser();

  const { addToast } = useToasts();
  const [material, setMaterial] = useState(undefined);

  useEffect(() => {
    if (lessonItem) {
      getMaterial();
    }
  }, [lessonItem]);

  async function getMaterial() {
    try {
      const _data = await getLessonItemService(lessonItem?.lesson_item_guid || lessonItem?.lesson_item_id, lesson?.guid || lesson?.id, course, currentUser);
      const didacticType = lessonItem?.didactic_types?.length > 0 ? lessonItem?.didactic_types[0] : null;

      // Determinar el typeName
      let typeName = t('lesson:Instructions');
      if (didacticType?.name) {
        typeName = didacticType.name;
      } else if (_data?.typeName) {
        typeName = _data.typeName;
      }

      setMaterial({
        ..._data,
        typeName,
        icon: didacticType?.icon ? didacticType.icon : _data.icon,
      });
      if (!_data?.course_messages_guid && !course?.isReadOnly) {
        initMessagesGuid(_data);
      }
    } catch (error) {
      console.log('error', error);
      addToast(t('Error'), { appearance: 'error', autoDismiss: true });
    }
  }

  async function initMessagesGuid(data) {
    try {
      const _post = await postMessaje({
        courseGuid,
        data: { message: 'message-container', message_for: 'all', lesson_item_guid: data.guid },
      });
      setMaterial((prevMaterial) => ({ ...prevMaterial, course_messages_guid: _post.data.data.guid }));
    } catch {
      addToast(t('Error'), { appearance: 'error', autoDismiss: true });
    }
  }

  function onClickSuccess(event) {
    const isQuizTask = material?.content_type_guid === CONTENT_TYPES.TEST || material?.content_type_guid === CONTENT_TYPES.QUESTION;
    const isVideoLesson = material?.content_type_guid === CONTENT_TYPES.VIDEOLESSON;
    event.stopPropagation();

    if (isQuizTask || isVideoLesson) {
      onClickOpenDetailedView(lessonItem);
    } else {
      if (isNativeAppWebview() && material?.content_type_guid === CONTENT_TYPES.XAPI) {
        window.open(`/viewer-v1/${material.content_guid}`);
      } else {
        window.open(`/viewerfull/${material.content_guid}`, '_blank');
      }
    }
  }

  return { material, onClickSuccess };
}

export default useMaterial;
